// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error404 {\n  align-items: center;\n  justify-content: center;\n  min-height: 500px;\n}", "",{"version":3,"sources":["webpack://src/pages/Error404/_error404.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,uBAAA;EACA,iBAAA;AACF","sourcesContent":[".error404 {\n  align-items: center;\n  justify-content: center;\n  min-height: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
